import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { BasicError, err, ok } from "@nju/result";
import { IChangePasswordResult } from "./types";
import { verificationErrorResponse } from "./validators";

export async function changePassword(
  oldPassword: string,
  newPassword: string,
): Promise<IChangePasswordResult> {
  const result = await client(
    `${process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST}/users/preferences`,
    {
      method: "patch",
      headers: {
        "Accept-Language": "pl",
        "Client-Id": process.env.NEXT_PUBLIC_CLIENT_ID || "unknown",
      },
      json: [
        {
          op: "test",
          path: "/credentials/password",
          value: oldPassword,
        },
        {
          op: "replace",
          path: "/credentials/password",
          value: newPassword,
        },
      ],
    },
  );

  if (result.isError) {
    const errorInfo = verificationErrorResponse.safeParse(
      result.err.extra?.json,
    );

    if (errorInfo.success) {
      if (errorInfo.data.code === "50142") {
        return err(
          new BasicError({
            message: "invalid current password",
            code: "INVALID_CURRENT_PASSWORD",
          }),
        );
      }
      if (errorInfo.data.code === "50157") {
        return err(
          new BasicError({
            message: "same password",
            code: "NEW_PASSWORD_SAME_AS_CURRENT",
          }),
        );
      }
      if (errorInfo.data.code === "50257") {
        return err(
          new BasicError({
            message: "last 5 passwords",
            code: "LAST_FIVE_PASSWORDS",
          }),
        );
      }
    }
    Bugsnag.notify(result.err);
    return result;
  }

  return ok(undefined);
}
